import type { TFunction } from "i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

type VisitDetails = {
  priceRange?: string | null;
  durationMinutes?: number | null;
};

type VisitPrice = {
  label: string;
  isFree: boolean;
};

const isFreeVisit = (priceRange?: string | null) => priceRange?.trim().toLowerCase() === "free";

const formatVisitPrice = (
  t: TFunction,
  { priceRange, durationMinutes }: VisitDetails
): VisitPrice | undefined => {
  if (!priceRange) return undefined;

  const isFree = isFreeVisit(priceRange);

  if (!durationMinutes) return { label: priceRange, isFree };

  if (isFree) {
    return {
      label: t(l.connect.practitionerCard.freeVisitDuration, { durationMinutes }),
      isFree,
    };
  }

  return {
    label: t(l.connect.practitionerCard.visitPriceAndDuration, {
      price: priceRange,
      durationMinutes,
      interpolation: { escapeValue: false },
    }),
    isFree,
  };
};

export { formatVisitPrice };
